interface IconProps {
  name: string;
  className?: string;
}

export default function Icon({ name, className = "w-5 h-5" }: IconProps) {
  return (
    <span className={`inline-flex items-center justify-center leading-none ${className}`}>
      <i className={`${name} leading-none`}></i>
    </span>
  );
}